import { useFullscreen } from "../../../contexts/FullScreenContext";
import { useDashboardDomainContext } from "../../../DashboardDomainProvider";
import { CardTileBody } from "./CardTiles/CardTileBody";
import { CardTileHeader } from "./CardTiles/CardTileHeader";

const FullscreenOverlay = ({ card }) => {
    const { closeFullscreen } = useFullscreen();
    const { getVisualFromCard} = useDashboardDomainContext();
    const visual = getVisualFromCard(card);



    if (!visual) 
        return <div className="card-tile-body empty" />;

    return (
        <div className="overlay" onClick={closeFullscreen}>
            {card &&
                <div className={`card-cell card-overlay`} onClick={(e) => e.stopPropagation()}>
                    <div className={'inner'}>
                        <CardTileHeader isOverlay={true} card={card} visual={visual} />
                        <CardTileBody card={card} visual={visual} />
                    </div>
                </div>
            }
        </div >
    );
};

export default FullscreenOverlay;
